// Helper function to create an iframe for hosted fields
export function createIframe(fieldId, placeholder, styles) {
    const iframe = document.createElement("iframe");
    iframe.setAttribute("id", `cardform-${fieldId}`);
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("scrolling", "no");
    iframe.setAttribute("allowtransparency", "true");
    iframe.style.width = "100%";
    iframe.style.height = "40px";
    iframe.style.border = styles.border || "1px solid #ccc";
    iframe.style.borderRadius = styles.borderRadius || "4px";
    iframe.style.padding = "0";
    iframe.style.marginBottom = styles.marginBottom || "8px";
    iframe.style.fontSize = styles.fontSize || "16px";
    iframe.style.background = styles.background || "#fff";
    iframe.style.display = "block";
  
    const iframeContent = `
      <html>
        <head>
          <style>
            html, body { 
              margin: 0; 
              padding: 0;
              font-family: Arial, sans-serif; 
              height: 100%;
              width: 100%;
            }
            input {
              width: 100%;
              height: 100%;
              border: none;
              outline: none;
              font-size: ${styles.fontSize || "16px"};
              box-sizing: border-box;
              background: ${styles.background || "#fff"};
              color: ${styles.textColor || "#000"};
              padding: 10px;
            }
            input::placeholder {
              color: ${styles.placeholderColor || "#aaa"};
            }
            input:focus {
              outline: none;
            }
          </style>
        </head>
        <body>
          <input type="${fieldId === "secret" ? "password" : "text"}"
                 id="${fieldId}-input"
                 placeholder="${placeholder}" />
          <script>
            const input = document.getElementById("${fieldId}-input");
            let hasTyped = false;
            input.focus();
            input.addEventListener("input", (e) => {
              hasTyped = true;
              let value = e.target.value || "";
              ${
                fieldId === "card"
                  ? `
              value = value.replace(/\\D/g, "").substring(0, 16);
              const parts = value.match(/.{1,4}/g);
              e.target.value = parts ? parts.join(" ") : value;
              `
                  : fieldId === "expiry_date"
                  ? `
              value = value.replace(/[^0-9]/g, "");
              if (value.length > 2) {
                value = value.substring(0, 2) + '/' + value.substring(2, 4);
              }
              e.target.value = value;
              `
                  : ""
              }
              window.parent.postMessage({
                field: "${fieldId}",
                value: e.target.value,
                event: "input",
                hasTyped
              }, "*");
            });
            input.addEventListener("blur", () => {
              window.parent.postMessage({
                field: "${fieldId}",
                value: input.value || "",
                event: "blur",
                hasTyped
              }, "*");
            });
            ${
              fieldId === "expiry_date"
                ? `
            input.addEventListener("keydown", (e) => {
              const val = input.value;
              if (e.key === "Backspace" && val.length === 3 && val[2] === "/") {
                e.preventDefault();
                input.value = val.substring(0, 2);
              }
            });
            `
                : ""
            }
          </script>
        </body>
      </html>
    `;
    iframe.srcdoc = iframeContent;
    return iframe;
  }